import React from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  MessageCircle,
  MapPin,
  Phone,
  Mail,
  ShieldCheck,
  LayoutGrid,
} from "lucide-react";
import Logo from "./Logo";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black/90 backdrop-blur-xl border-t border-white/5 pt-16 pb-8 relative z-10 transition-all duration-500">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="flex flex-col items-center space-y-6 w-full">
            <div className="flex flex-col items-center justify-center w-full group cursor-default">
              <Logo className="" showScan={false} />
            </div>

            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/NEOtecOficia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/5 flex items-center justify-center text-white/40 hover:bg-red-600 hover:text-white transition-all duration-300 group"
                aria-label="Facebook"
              >
                <Facebook
                  size={20}
                  className="group-hover:scale-110 transition-transform"
                />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/5 flex items-center justify-center text-white/40 hover:bg-red-600 hover:text-white transition-all duration-300 group"
                aria-label="Instagram"
              >
                <Instagram
                  size={20}
                  className="group-hover:scale-110 transition-transform"
                />
              </a>
              <a
                href="https://wa.me/59160722786"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/5 flex items-center justify-center text-white/40 hover:bg-red-600 hover:text-white transition-all duration-300 group"
                aria-label="WhatsApp"
              >
                <MessageCircle
                  size={20}
                  className="group-hover:scale-110 transition-transform"
                />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-start">
            <h3 className="text-white font-bold mb-6 text-lg tracking-tight">
              Enlaces Rápidos
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-white/50 hover:text-red-500 transition-all flex items-center gap-3 text-sm font-medium group"
                >
                  <LayoutGrid size={18} className="group-hover:text-red-500" />
                  Catálogo Pro
                </Link>
              </li>
              <li>
                <Link
                  to="/admin"
                  className="text-white/50 hover:text-red-500 transition-all flex items-center gap-3 text-sm font-medium group"
                >
                  <ShieldCheck size={18} className="group-hover:text-red-500" />
                  Panel Admin
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-start text-left">
            <h3 className="text-white font-bold mb-6 text-lg tracking-tight">
              Contacto
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-4 text-white/60 text-sm">
                <MapPin
                  size={20}
                  className="text-red-500 mt-0.5 flex-shrink-0"
                />
                <span className="font-medium">
                  Calle Esteban Arce 1347, GALERIA "FLORITA" Local 2,
                  Cochabamba, Bolivia
                </span>
              </li>
              <li className="flex items-center gap-4 text-white/40 text-sm font-medium">
                <Phone size={20} className="text-red-500 flex-shrink-0" />
                <span>+591 607 22786</span>
              </li>
              <li className="flex items-center gap-4 text-white/40 text-sm font-medium">
                <Mail size={20} className="text-red-500 flex-shrink-0" />
                <span>solutionvaldez@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Horario */}
          <div className="flex flex-col items-start w-full">
            <h3 className="text-white font-bold mb-6 text-lg tracking-tight">
              Horario
            </h3>
            <ul className="space-y-3 text-white/50 text-xs font-medium w-full">
              <li className="flex justify-between border-b border-white/5 pb-2">
                <span>Lunes - Viernes:</span>
                <span className="text-white">9:00 - 19:00</span>
              </li>
              <li className="flex justify-between border-b border-white/5 pb-2">
                <span>Sábados:</span>
                <span className="text-white">9:00 - 19:00</span>
              </li>
              <li className="flex justify-between">
                <span>Domingos:</span>
                <span className="text-red-600 font-black">Cerrado</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/20 text-[10px] font-bold uppercase tracking-widest text-center md:text-left">
            &copy; {currentYear} NEOtec Soluciones Informáticas. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6 text-sm text-neutral-500">
            <a href="#" className="hover:text-white transition-colors">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
